module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "FMH2",
    attrs: {
      "id": "_idParaDest-3"
    }
  }, [_c('span', {
    staticClass: "rh CharOverride-3"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  }, [_c('span', {
    staticClass: "rh"
  }, [_vm._v("PROLOGUE")])])]), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  }, [_c('p', {
    staticClass: "FMSH"
  }, [_c('span', {
    staticClass: "fmsh CharOverride-6"
  }, [_vm._v("SEPTEMBER ")]), _vm._v("15, 1864")]), _vm._v(" "), _c('p', {
    staticClass: "FMOT"
  }, [_vm._v("Soon it will be over.")])]), _c('p', {
    staticClass: "FMTX"
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }, [_vm._v("John Hanning Speke has waited five years for the verdict. Now, on the eve of the great debate that will decide the outcome, he stalks through the dying grass of his uncle’s estate in soft, precise steps. A Lancaster breechloader shotgun is cradled in the crook of his right arm. The left barrel is cocked and ready to shoot. George’s man beats the brush out front, doing his best, but having an unlucky day scaring up partridge. The ancient Romans used to call such men “explorers,” from the Latin "), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("explorare")]), _vm._v("—“to cry out.” But the definition has changed. No longer does it only apply to men who wander ahead in the fields and flush game. Now it also defines those adventurers ")]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("who travel deep into undiscovered lands, then return to civilization to tell others what they saw.")])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('p', {
    staticClass: "FMTX"
  }, [_vm._v("Which is why, on this day, Daniel Davis is more commonly known as a groundskeeper, while John Hanning Speke is famous around the world as an explorer.")]), _vm._v(" "), _c('p', {
    staticClass: "FMTX"
  }, [_vm._v("George Fuller himself, Speke’s cousin, walks sixty yards to his right. This way their fields of fire don’t overlap. Not that it matters—Speke and Fuller have pulled the trigger twice in the past two hours, hitting nothing at all.")]), _vm._v(" "), _c('p', {
    staticClass: "FMTX"
  }, [_vm._v("Speke is unbothered by their failure. Killing small birds is not why he insisted on a few hours in the fields before dinner. The hunt is Speke’s escape. Before he was an explorer, before Burton and the Nile, and before the public accusations that made his life a living hell, he was a hunter. He stalked and killed beasts of all sizes and ferocity, in Europe and Asia and Africa. His prowess is so renowned that a rare species of gazelle was named in his honor—a species that he personally discovered and then promptly shot. The hunt is where his nerves grow calm and insecurities cannot intrude. Everything is simple on the hunt, just like Speke. The fancy words and well-crafted arguments of a hedonist intellectual like Richard Francis Burton have no place.")]), _vm._v(" "), _c('p', {
    staticClass: "FMTX"
  }, [_vm._v("Today, of all days, as Speke’s mind races and he tries to arrange his words for that moment tomorrow morning when he will gingerly step up onto the speaker’s platform before a crowd that will be no less ferocious than a lion in the wild, he desperately needs the clarity and calm of the hunt.")])]), _c('p', {
    staticClass: "FMTX"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("The field here at Neston Park, as the Fuller family estate is known, is separated from another by a two-foot-high stone wall. The young aristocrat can easily step over with the shotgun in his hand, but he chooses to wedge the butt in the rocks, so that the barrels point to the sky.")])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "FMTX"
  }, [_vm._v("Tomorrow Speke will travel to Bath and debate Richard Francis Burton in the great auditorium. The newspapers are calling it the Nile Debate. Tickets are sold out. Thousands are taking the train from London to decide for themselves which man discovered the source of the Nile River, solving a geographical mystery that has perplexed mankind since the ancient Egyptians.")]), _vm._v(" "), _c('p', {
    staticClass: "FMTX"
  }, [_vm._v("The winner will be known throughout history for the achievement. He will be wealthy and famous, and a legend in his own time—if not forever.")]), _vm._v(" "), _c('p', {
    staticClass: "FMTX"
  }, [_vm._v("The loser will be disgraced and considered a fraud, his every accomplishment subject to newfound scrutiny.")]), _vm._v(" "), _c('p', {
    staticClass: "FMTX"
  }, [_vm._v("It will all come down to how each man presents his argument. This is where Speke is at a disadvantage. Never mind that he has traveled into deepest Africa on three occasions, risking his life in the name of exploration. Or that his travels have been more epic, and have revealed far more about the unknown world, than Burton’s. No one in the audience will care about anything but the Nile, and which of them persuades them that he is the very special man who found that hole in the ground from which it springs.")])]), _c('p', {
    staticClass: "FMTX"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("Speke is an anxious, celibate loner. Burton is a black-eyed, ")]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("priapic genius for whom exploration is secondary to learning obscure languages and having sex with native women. Speke knows that Burton will try to ruin him; that the former friend with the scars across both cheeks will stop at nothing to humiliate, to embarrass, and to destroy.")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('p', {
    staticClass: "FMTX"
  }, [_vm._v("But he feels powerless to stop him. Speke’s stumbling public speaking and limited intellectual capacity pale in comparison to Burton’s dazzling oratory.")]), _vm._v(" "), _c('p', {
    staticClass: "FMTX"
  }, [_vm._v("It is not hard for Speke to imagine the golden words that will spill forth from Burton’s lips tomorrow, convincing one and all in rational, thoughtful sentences, planting great seeds of doubt about Speke’s theories.")]), _vm._v(" "), _c('p', {
    staticClass: "FMTX"
  }, [_vm._v("Those seeds will be followed by whispers of derision from the audience, building to scorn and perhaps even laughter as the debate progresses. Speke knows it. Burton, who already awaits him in Bath, knows it. All of England knows it, thanks to the newspapers making much of the Nile duel. The thought is almost too much to bear.")]), _vm._v(" "), _c('p', {
    staticClass: "FMTX"
  }, [_vm._v("The Lancaster has no safety. Speke feels the shotgun muzzle push against his breast as he straddles the stone wall. He puts his hand atop the smooth rocks to brace himself, even as the weight of his body presses down hard on the twenty-eight-inch Damascus steel barrels.")]), _vm._v(" "), _c('p', {
    staticClass: "FMTX"
  }, [_vm._v("He has no choice. No choice at all.")]), _vm._v(" "), _c('p', {
    staticClass: "FMTX"
  }, [_vm._v("The air smells like rain. Dusk is falling.")]), _vm._v(" "), _c('p', {
    staticClass: "FMTX"
  }, [_vm._v("Meanwhile, in Bath, Burton awaits.")])])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3db1f217","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pro.vue
// module id = 78
// module chunks = 0